import axios from "./axios";

export const allProjects = async () => {
  try {
    const response = await axios.get(`client-projects?page=1&pageSize=10000`);
    if (response.status === 200) {
      return response.data;
    } else {
      return response;
    }
  } catch (error) {
    return error;
  }
};
export const clientProjectsDetails = async (showLoader, hideLoader, slogan) => {
  showLoader();
  try {
    const response = await axios.get(`client-projects/slogan/${slogan}`);
    if (response.status === 200) {
      return response.data;
    } else {
      hideLoader();
      return response;
    }
  } catch (error) {
    hideLoader();
    return error;
  }
};
export const getNftById = async (showLoader, hideLoader, slogan, id) => {
  showLoader();
  try {
    const response = await axios.get(`opensea/token/${id}/${slogan}`);
    hideLoader();
    if (response.status === 200) {
      return response.data;
    } else {
      return response;
    }
  } catch (error) {
    hideLoader();
    return error;
  }
};

export const getTutorialCategories = async (showLoader, hideLoader) => {
  showLoader();
  try {
    const response = await axios.get(`categories/withSubCat`);
    hideLoader();
    if (response.status === 200) {
      return response.data;
    } else {
      return response;
    }
  } catch (error) {
    hideLoader();
    return error;
  }
};

export const getTutorials = async (id) => {
  try {
    const response = await axios.get(
      `tutorials/getTutorialsByCategoryId/${id}`
    );
    if (response.status === 200) {
      return response.data;
    } else {
      return response;
    }
  } catch (error) {
    return error;
  }
};

export const createTicket = async (body) => {
  try {
    const response = await axios.post(`tickets`, body, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    if (response.status === 201) {
      return response?.data;
    } else {
      return response;
    }
  } catch (error) {
    return error;
  }
};

export const getTickets = async (showLoader, hideLoader) => {
  showLoader();
  try {
    const response = await axios.get(`tickets/user`);
    if (response.status === 200) {
      hideLoader();
      return response.data;
    } else {
      return response;
    }
  } catch (error) {
    hideLoader();
    return error;
  }
};

export const getTicketDetailById = async (showLoader, hideLoader, ticketId) => {
  showLoader();
  try {
    const response = await axios.get(`tickets/${ticketId}`);
    if (response.status === 200) {
      hideLoader();
      return response.data;
    } else {
      return response;
    }
  } catch (error) {
    hideLoader();
    return error;
  }
};

export const sendTicketMessage = async (ticketId, messageBody) => {
  try {
    const response = await axios.post(
      `tickets/${ticketId}/messages`,
      messageBody,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    if (response.status === 201) {
      return response.data;
    } else {
      return response;
    }
  } catch (error) {
    return error;
  }
};

export const markAllTicketNoficationsAsRead = async () => {
  try {
    const response = await axios.put(`notifications/read-all`);
    if (response.status === 200) {
      return response.data;
    } else {
      return response;
    }
  } catch (error) {
    return error;
  }
};
